import React from 'react'
import { Hero } from './components/Hero'
import { TwoColumns } from './components/TwoColumns'
import { Benefits } from './components/Benefits'
import { Reviews } from './components/Reviews'
import { PageWrapper } from './styled'

export const Landing = () => {
  return (
    <PageWrapper>
      <Hero />
      <TwoColumns />
      <Benefits />
      <Reviews />
    </PageWrapper>
  )
}
